export const RESOURCE_ACCESS = "hcc-phenostation-fe";
export const ACCESS_ROLE = "web-access";
